__turbopack_context__.v({
  "DropdownContent": "S-JZ4q_DropdownContent",
  "DropdownContent--Active": "S-JZ4q_DropdownContent--Active",
  "DropdownContent__Header": "S-JZ4q_DropdownContent__Header",
  "DropdownContent__Icon": "S-JZ4q_DropdownContent__Icon",
  "DropdownContent__Item": "S-JZ4q_DropdownContent__Item",
  "DropdownContent__Link": "S-JZ4q_DropdownContent__Link",
  "DropdownContent__List": "S-JZ4q_DropdownContent__List",
  "DropdownContent__Nav": "S-JZ4q_DropdownContent__Nav",
  "DropdownContent__NoHeader": "S-JZ4q_DropdownContent__NoHeader",
});
